import React, {FC, useEffect, useState, MouseEvent}  from 'react';
import { useNavigate } from 'react-router-dom';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton} from '@mui/material';
import {Refresh as RefreshIcon } from '@mui/icons-material';
// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation, } from "react-query";
import { useTranslation  } from 'react-i18next';

// import user Component

import EnhancedTable, {EnhancedTableProps, HeadCell,EnhancedTableToolbarProps } from '../../ui/EnhancedTable';

// import user Library.
import {useUserStore} from '../../library/store'; 
import IBankPerson, {IBankPersonSearch, defaultBankPerson} from './model/BankPerson';

import useBankPersonService from './service/BankPerson';


interface BankPersonListFormProps {
  onRowDoubleClick? : (event: React.MouseEvent<unknown>, bankPerson: IBankPerson) => void
}

const BankPersonListForm: FC<BankPersonListFormProps> = (props :BankPersonListFormProps) => {

  const {onRowDoubleClick} = props;

  const { setCurrentEntity, currentUser} = useUserStore();
  const {language: lg} = currentUser;

  const {getBankPersonsList} = useBankPersonService();

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [headPersonCells, setHeadPersonCells]  = useState<HeadCell<IBankPerson>[]>([
    
    {id:'civility', label : t('Civility'),  display: true, type: 'string'},

    {id:lg.startsWith('fr')?'lastName':'firstName', label : t(lg.startsWith('fr')?'Last Name':'First Name'),  display: true, type: 'string'},
    {id:lg.startsWith('fr')?'firstName':'lastName', label : t(lg.startsWith('fr')?'First Name':'Last Name'),  display: true, type: 'string'},  
 
    
    {id:'birthDate', label : t('Birth Date'),  display: true, type: 'date'}, 
    {id:'birthPlace', label : t('BirthPlace'),  display: true, type: 'string'},   
    
    {id:'portable1', label : t('Portable1'),  display: true, type: 'string'},   
    ]);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [personNameNIC, setPersonNameNIC] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [birthYear, setBirthYear] = useState(0);
  const [birthMonth, setBirthMonth] = useState(0);

  const {getValues, register} = useForm<IBankPersonSearch>( {defaultValues:{firstName, lastName, 
      personNameNIC, phoneNumber, birthYear, birthMonth}} );

  const {isSuccess: isBankPersonsSuccess, status: bankPersonsStatus,refetch: refetchBankPersons,data: bankPersons} = 
      useQuery<IBankPerson[]>(['BankPersons', firstName, lastName, personNameNIC, phoneNumber, birthYear, birthMonth], 
        () => getBankPersonsList( {firstName, lastName, personNameNIC, phoneNumber, birthYear, birthMonth} ),
      {enabled: firstName !== '' || lastName !== '' || personNameNIC !== '' || 
                phoneNumber !== '' || birthYear !== 0 || birthMonth !== 0   } );

   
    // useQuery<IBankPerson>(['Product', ], () => getBankPersonsList('', '', '', '', 0,0,), 
    //     {enabled: ('currentProductCode' !== '' /*&& currentProduct.productCode !== currentProductCode*/  ) } );
    const defaultHandleRowDoubleClick = (event: React.MouseEvent<unknown>, bankPerson: IBankPerson) => {
      const selectBankPersonID = bankPerson.bankPersonID || 0;     

      if(selectBankPersonID > 0)         
        navigate(`/bankPerson/${selectBankPersonID}`);          
    }

  //useEffect( () => {setCurrentEntity('BankPersonList');}, [] );
  const handleRefreshList = (event : any) => {
    const {firstName, lastName, personNameNIC, phoneNumber, birthYear, birthMonth} = getValues();
    setFirstName(firstName);
    setLastName(lastName);
    setPersonNameNIC(personNameNIC);
    setPhoneNumber(phoneNumber);
    setBirthYear(birthYear);
    setBirthMonth(birthMonth);
  }

  const listData = async (event: MouseEvent<HTMLButtonElement>) => {
    handleRefreshList(event);
  }
  

    return (
      <>
        <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
          <Grid item xs={12}  component={Paper} elevation={6} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <TextField  sx={{width:'calc(20% - 8px)'}} id={lg.startsWith('fr')?'lastName':'firstName'} label={t(lg.startsWith('fr')?'Last Name':'First Name')} {...register(lg.startsWith('fr')?'lastName':'firstName')} />     
                  <TextField  sx={{width:'calc(20% - 8px)'}} id={lg.startsWith('fr')?'firstName':'lastName'} label={t(lg.startsWith('fr')?'First Name':'Last Name')} {...register(lg.startsWith('fr')?'firstName':'lastName')} /> 
                      
                  <TextField  sx={{width:'calc(10% - 8px)'}} id="portable1" label={t('Portable1')}  {...register('phoneNumber')} /> 
                  <TextField  sx={{width:'calc(10% - 8px)'}} id="roleName" label={t('Birth Year')} {...register('birthYear')} /> 
                  <TextField  sx={{width:'calc(10% - 8px)'}} id="roleName" label={t('Birth Month')} {...register('birthMonth')} />
                  
                  <Button id='btnList' onClick={listData} sx={ {display:'none'}}  /> 
                </Box>  
                <Box sx={{ mt: 1, width: '100%' }} >                      
                  { <EnhancedTable<IBankPerson> headCells={headPersonCells} rows={bankPersons || []} order='asc' orderBy='personID'
                    title='Liste Personnes...' objKey='personID'  //onRowSelected={handleRoleItemSelected}
                    onRowDoubleClick={onRowDoubleClick?onRowDoubleClick:defaultHandleRowDoubleClick}
                    toolbarActions={[ { toolTip: 'Refresh...', onClickIcon: handleRefreshList ,icon: RefreshIcon } ]} />   }    
                               
                </Box>     
              </Box>
          </Grid>         
        </Grid>
      </>
    );
  }
  
  export default BankPersonListForm;